<template>
  <canvas ref="canvas" class="confetti" />
</template>

<script>
import { reducedMotion } from '../../lib/motion';
export default {
  name: 'ConfettiBurst',
  // Substitui a dependência de `canvas-confetti` vinda de CDN de terceiro, que ficava no
  // caminho crítico de renderização de toda visita. Ver docs/TECHNICAL_DEBT.md § 13.
  mounted() {
    if (reducedMotion()) return;
    this.$nextTick(this.burst);
  },
  beforeUnmount() {
    this.stopped = true;
  },
  methods: {
    burst() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;

      const box = canvas.parentElement.getBoundingClientRect();
      canvas.width = box.width;
      canvas.height = box.height;
      const ctx = canvas.getContext('2d');
      const css = getComputedStyle(document.documentElement);
      // Tokens da marca. Os nomes antigos (`--accent`, `--gold`) morreram na nova
      // interface, e `getPropertyValue` devolvia string vazia: `fillStyle` recusa o valor
      // inválido, mantém o preto do contexto, e o confete caía em preto sobre o grafite.
      const cores = ['--violet', '--magenta', '--link-blue', '--link-pink', '--amber', '--ok']
        .map((t) => css.getPropertyValue(t).trim())
        .filter(Boolean);

      const particulas = Array.from({ length: 90 }, (_, i) => ({
        x: box.width * (0.2 + Math.random() * 0.6),
        y: box.height * 0.18,
        vx: (Math.random() - 0.5) * 5.5,
        vy: -Math.random() * 7 - 2.5,
        w: 4 + Math.random() * 5,
        h: 3 + Math.random() * 4,
        r: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        c: cores[i % cores.length],
      }));

      const start = performance.now();
      const frame = (now) => {
        if (this.stopped || !this.$refs.canvas) return;
        const elapsed = now - start;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        particulas.forEach((p) => {
          p.vy += 0.19;
          p.x += p.vx;
          p.y += p.vy;
          p.r += p.vr;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.r);
          ctx.globalAlpha = Math.max(0, 1 - elapsed / 2400);
          ctx.fillStyle = p.c;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        });

        if (elapsed < 2400) requestAnimationFrame(frame);
        else ctx.clearRect(0, 0, canvas.width, canvas.height);
      };
      requestAnimationFrame(frame);
    },
  },
};
</script>

<style scoped>
.confetti {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
}
</style>
